function e(r){return{flags:r.flags,data:null,error:r.error,initialFlagState:{input:r.input,outcome:{error:r.error}},cookie:r.cookie}}export{e as a};
